import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IHandheldProfile extends IBaseEntity {
    id: number;
    name?: string;
    description?: string;
    writeSettings?: any;
    readSettings?: any[];
}

export class HandheldProfile extends BaseEntity implements IHandheldProfile {
    public id;
    public name;
    public description;
    public writeSettings: any;
    public readSettings: any[];

    constructor(handheldProfile?) {
        super();
        if (handheldProfile) {
            this.id = handheldProfile.id;
            this.name = handheldProfile.name;
            this.description = handheldProfile.description;
            this.writeSettings = handheldProfile.writeSettings;
            this.readSettings = handheldProfile.readSettings || [];
        } else {
            this.readSettings = [];
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): HandheldProfile {
        return new HandheldProfile(this);
    }
}
